$('.ingredients-block__list').slick({
  slidesToShow: 1,
  dots:false,
  appendArrows: $('.ingredients-block__list-block'),
  prevArrow: '<button class="ingredients-block__list-arrow"></button>',
  nextArrow: '<button class="ingredients-block__list-arrow ingredients-block__list-arrow--right"></button>'
});

var imgSlider = $('.ameon-product__list').slick({
  slidesToShow: 1,
  dots:false,
  prevArrow: false,
  nextArrow: false
});

imgSlider.on('beforeChange', function (evt, slick, current, nextSlide) {
  $('.ameon-product__item-small--active').removeClass('ameon-product__item-small--active');
  $('.ameon-product__item-small').eq(nextSlide).addClass('ameon-product__item-small--active')
})

$('.ameon-product__item-small').on('click touch', function () {
  var index = $(this).index();
  $('.ameon-product__list').slick('slickGoTo', index);
})

$('.ingredients-block__item-button').on('click touch', function () {
  $('.ingredients-block__list-block').addClass('ingredients-block__list-block--active');
});

$('.ingredients-block__modal-close').on('click touch', function () {
  $('.ingredients-block__list-block').removeClass('ingredients-block__list-block--active');
});

$('.info-product__block-desc').on('click touch', function() {
  var isOpen = $(this).hasClass('active');

  $('.info-product__block-desc').next().slideUp();
  $('.info-product__block-desc.active').removeClass('active');
  $('.info-product__block').removeClass('info-product__block--active');

  if (!isOpen) {
    $(this).next().slideDown();
    $(this).addClass('active');
    $(this).parent().addClass('info-product__block--active');
  }
});

$('.faq-block__tit').on('click touch', function() {
  var isOpen = $(this).hasClass('active');

  $('.faq-block__tit').next().slideUp();
  $('.faq-block__tit.active').removeClass('active');

  if (!isOpen) {
    $(this).next().slideDown().css('display', 'flex');
    $(this).addClass('active');
  }
});

$('.set-step__list').slick({
  slidesToShow: 1,
  dots:true,
  arrows: false,
});

$('.big-product__list').slick({
  slidesToShow: 1,
  dots:true,
  arrows: false,
});

$('.consist-list').slick({
  slidesToShow: 5,
  slidesToScroll: 5,
  dots:true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
});

$('.study-block__slider-imgs').slick({
  slidesToShow: 1,
  dots:true,
  arrows: false,
  adaptiveHeight: false,
});

if ($(window).width() <= 768) {
  $('.change-skin__blocks').slick({
    slidesToShow: 1,
    centerMode: true,
    dots:true,
    arrows: false,
    adaptiveHeight: false,
  }); 
}

$(window).on('scroll', function() {
  scrollTop = $(window).scrollTop();
  if(scrollTop > 20) {
    $('.header__fix').addClass('header__fix--scroll')
  } else {
    $('.header__fix').removeClass('header__fix--scroll')
  }
})

function appHeight(){
  var doc = document.documentElement
  doc.style.setProperty('--app-height', window.innerHeight + 'px')
}

window.addEventListener('resize', appHeight)
appHeight()


$('.header__btn').click(function(e){
  e.stopPropagation();
  $('.menu').addClass('active');
  $('body').addClass('overlay');
  return false;
});

$('.menu__close').click(function(e){
  e.preventDefault()
  hideMenu()
});
function hideMenu() {
  $('.menu').removeClass('active');
  $('body').removeClass('overlay');
}


var showedReviews = 4;

$('.js-show-more-reviews').on('click touch', function (e) {
  e.preventDefault();
  showedReviews += 10;
  $(".ameon-review:lt(" + showedReviews + ")").css({
    display: 'flex'
  });
  var $self = $(this);
  var review = $('.ameon-review').last();
  $.ajax('https://review.useair.app/review/loadReviews?shopId=' + AIR_REVIEWS.settings.shopId + '&productId=' + AIR_REVIEWS.product.id + '&after=' + review.data('id')).then(function(d) {
    var html = '';    

    if (!d.data.hasNext) {
      $self.hide();
    }
    for (var i = 0; i < d.data.reviews.length; i++) {
      var r = d.data.reviews[i];
      var rate = r.rate;
      var rates = {};
      for (var j = 2; j <= 5; j++) {
        rates[j] = 100;
        if (rate <= j - 1) {
          rates[j] = 0;
        }
      }
      let reply = '';
      if (r.shopReply && r.shopReply.content && r.shopReply.content.trim()) {
        reply = '<div class="ameon-review__answer"><span class="ameon-review__answer-name">AMEŌN</span><p class="ameon-review__answer-txt">' + r.shopReply.content + '</p></div>';
      }
      let photos = '<div class="ameon-review__photos">';

      for (var k = 0; k < r.images.length; k++) {
          photos += '<a href="' + r.images[k] + '" data-lightbox="' + r.id  + '">'
          photos += '<img src="' + r.images[k] + '" alt="img" class="ameon-review__photo">';
          photos += '</a>';
      }
      photos += '</div>';
      html += 
        '<div class="ameon-review" data-id="' + r.id + '" data-shop="' + r.shopId + '"' + 'data-product="' + r.product.id + '">' +
            '<div class="ameon-review__left">' +
              '<span class="ameon-review__name">' +
                r.firstName +
              '</span>' +
              '<span class="ameon-review__date">' + reviewDateFormat(r.createdAt) + '</span>' +
            '</div>' +
            '<div class="ameon-review__right">' +
              '<div class="product__rating-stars">' + 
                '<div class="product__rating-star"><span></span></div>' +
                '<div class="product__rating-star"><span style="width:' + rates[2] + '%"></span></div>' +
                '<div class="product__rating-star"><span style="width:' + rates[3] + '%"></span></div>' +
                '<div class="product__rating-star"><span style="width:' + rates[4] + '%"></span></div>' +
                '<div class="product__rating-star"><span style="width:' + rates[5] + '%"></span></div>' +
              '</div>' +
              '<p class="ameon-review__txt">' +
                r.content + 
              '</p>' +
              reply +
              photos +
            '</div>' +
          '</div>';
    }
    $(html).insertBefore('.js-show-more-reviews');
  })

  return false;
})
function reviewDateFormat(date) {
  date = date.split('T');
  date = date[0].split('-');
  return date[1] + '/' + date[2] + '/' + date[0]
}
$('.js-write-a-review').on('click touch', function () {
  $('.write-review').fadeIn();
  return false;
})

$('.write-review__wrap').on('click touch', function (e) {
  e.stopPropagation();
})

$('.write-review, .write-review__close').on('click touch', function() {
  $('.write-review').fadeOut();
  return false;
})


var reviewFiles = [];
var reviewImages = [];

$('#review-image').on('change', async function (e) {

  for (let i = 0; i < e.target.files.length; i++) {
    if (e.target.files[i].size / (1024 * 1024) > 5) {
      alert('File size must be less than 5MB');
      return;
    }    
  }
  $('.write-review__block-file span').text('Uploading...')
  reviewFiles = [];
  reviewImages = [];
  var text = 'Image';
  var url = 'https://firebasestorage.googleapis.com/v0/b/air-reviews.appspot.com/o?name=submitReview/';
  url += AIR_REVIEWS.settings.shopId;
  url += '/';

  var $reviewButton = $(this).parents('.write-review__wrap').find('.button__product');
  $reviewButton.attr('disabled', true);
  $reviewButton.text('Uploading...');
  
  for (let i = 0; i < e.target.files.length; i++) {
    
    let u = url + (new Date()).getTime() + '_' + e.target.files[i].name;
    let f = new FormData();
    f.append('file', e.target.files[i]);
  
    let data = await fetch(u, {
      method: 'POST',
      body: f
    });
    d = await data.json();
    reviewFiles.push({
      fileType: d.contentType,
      pos: new Date().getTime(),
      src: u + '&alt=media&token=' + d.downloadTokens,
      uploaded: true,
    })
    reviewImages.push(u + '&alt=media&token=' + d.downloadTokens);
  }
  if (e.target.files.length > 1) {
    text += 's';
  }
  $('.write-review__block-file').addClass('write-review__block-file--file');
  $('.write-review__block-file span').text(text + ' added');
  $reviewButton.attr('disabled', false);
  $reviewButton.text('Send');

});

$(".modal-waitlist__form").on('submit', function () {
  var email = $(this).find('input').val();
  var list = $(this).data('list');
  $.ajax({
    type: 'post',
    url: 'https://api.ameonskin.com/v1/email/subcribe',
    data: {
      a: 'backinstock',
      email: email,
      list_id: list
    },
    dataType: 'json'
  });
  $(this).hide();
  $(this).parent().find('.modal-waitlist__txt').show();
  return false;
})

$('.js-close-popup').on('click touch', function () {
  $(this).parents('.modal__wrapper').fadeOut();
})

// $('.js-submit-subscribe').on('submit', function () {
//   $.ajax({
//     type: 'post',
//     url: '/contact',
//     data: $(this).serialize()
//   });
//   $(this).parents('.modal__wrapper').hide();
//   $('.modal__wrapper--success').fadeIn();
//   return false;
// })


if (document.location.href.indexOf('customer_posted') !== -1 || document.location.href.indexOf('form_type=customer') !== -1) {
  $('.modal__wrapper--success').fadeIn();
}

$('.modal__wrapper').on('click touch', function () {
  $('.modal__wrapper').fadeOut();
})
$('.modal-block').on('click touch', function (e) {
  e.stopPropagation();
})

$('.small-product__video').on('mouseout', function () {
  $(this)[0].pause();
  $(this)[0].currentTime = 0;
})

$('.small-product__video').on('mouseover', function () {
  $(this)[0].play();
})

var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);


$('.wellness__imgs').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  dots:true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
  ]
});

if ($(window).width() < 768) {
  $('.press__list .press__item:nth-child(2)').prependTo($('.press__list'));
}

$('.press__list').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  dots:true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$('.big-slider__list').slick({
  slidesToShow: 3,
  dots:true,
  arrows: false,
  slidesToScroll: 3,
  variableWidth: true,
  //centerMode: true,
  centerPadding: '0',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //centerMode: true,
      }
    }
  ]
});

$('.promo-modal, .promo-modal__close').on('click touch', function() {
  $('body').removeClass('cart_open');
  $('.promo-modal').hide();
});

$('.promo-modal__block').on('click touch', function (e) {
  e.stopPropagation();
})

if (!localStorage.getItem('promo-summer-1') && $('.promo-modal').length) {
  // setTimeout(function () {
  //   $('body').addClass('cart_open');
  //   $('.promo-modal').show();
  //   localStorage.setItem('promo-summer-1', 1)
  // }, 12000)
}

$('.manifesto-info__list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:true,
  arrows: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

$('.js-quick-buy').on('click touch', function () {
  var $btn = $(this)
  function error() {
    $btn.attr('disabled', false);
    $btn.text('Buy');
    alert('Error has occurred. Please try once again.')
  }
  $btn.attr('disabled', true);
  //$btn.text('loading...')
  $.ajax({
    type: 'post',
    url: '/assets/components/minishop2/action.php',
    data: {
      ms2_action: 'cart/add',
      count: 1,
      id: $(this).data('id')
    },
    success: function (e) {
      if (e.success) {
        document.location.href = '/order'
      } else {
        error();
      }
    },
    error: error,
    dataType: 'json'
  });
  handleEcommerce('add', $btn);
  return false;
})


$('.write-review__wrap').on('submit', function (e) {
  e.preventDefault();
  $.ajax({
    url: 'https://review.useair.app/review/submit?id=',
    type: 'POST',
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify({
    "firstName": $(this).find('#user_name').val(),
    first_name: $(this).find('#user_name').val(),
    "email": $(this).find('#email').val(),
    "rate": $(this).serializeArray()[3]['value'],
    "content": $(this).find('#review').val(),
    "status": "disapproved",
    "shopId": AIR_REVIEWS.settings.shopId,
    "productId": AIR_REVIEWS.product.id,
    "shopDomain":"f52901-3.myshopify.com",
    "generalSettings":{"sortOption":"sortlarest@feedback","amzReviewerOption":"all_reviews","enableCountryFlag":false,"amzPhotoOption":"all_contents","enableAggregateRating":true,"amzSortOption":"recent","ratingOption":"All positive","photoOption":"all","amzRatingOption":"positive","autoSubmitPublish":"disabled"},
    files: reviewFiles,
    images: reviewImages,
    productSku: "",
    "productImage": 'https:' + AIR_REVIEWS.product.images[0],
    "productHandle": AIR_REVIEWS.product.handle,
    "productTitle": AIR_REVIEWS.product.title
  })});
  $('.write-review__wrap').hide();
  $('.write-review__wrap--success').show();
  return false;
})


$('.haart-info').find('.js-play-haart').on('click touch', function() {
  $('.haart-info__video')[0].play();
  $('.haart-info__video').attr('controls', true);
  $(this).hide();
  itemVideoPlaying = true;
})


$('.js-scrollto').on('click touch', function () {
  
  var body = $("html, body");
  body.stop().animate({scrollTop: $($(this).attr('href')).offset().top - 20}, 500);
  
  return false;
})



$('.service-compare').on('click touch', function () {
  $('.service-compare--active').removeClass('service-compare--active');
  $(this).addClass('service-compare--active');
  $('.service-compare__img--active').removeClass('service-compare__img--active');

  var index = $(this).index();

  $('.service-compare__img').eq(index).addClass('service-compare__img--active');
  return false;
})



$('.service-review__link').on('click', function () {
  $('.service-review').show();
  $(this).hide();
  return false;
})


$('.js-to-calendar').on('click touch', function () {
  var body = $("html, body");
  body.stop().animate({scrollTop: $('#calendar').offset().top - 20}, 500);
  
  return false;
})


if ($(window).width() <= 768) {
  $('.zorin-slide__imgs--1').slick({
       slidesToShow: 1,
       centerMode: true,
       dots:true,
       arrows: false,
       adaptiveHeight: false,
       dotsClass: 'slide__toggles',
       customPaging: function(slick,index) {
           var className = slick.currentSlide === index ? 'active' : '';
           return '<button class="' + className + '"/>';
       }
   }); 
 }
 
 
 
 
 $('.zorin-slide--2 .zorin-slide__imgs').slick({
   slidesToShow: 3,
   dots:true,
   arrows: false,
   adaptiveHeight: false,
   dotsClass: 'slide__toggles',
   customPaging: function(slick,index) {
       var className = slick.currentSlide === index ? 'active' : '';
       return '<button class="' + className + '"/>';
   }
 });
 


$('.digital-muses__block-slider_imgs').slick({
  slidesToShow: 1,
  dots:false,
  arrows: false,
  adaptiveHeight: false,
  autoplay: false,
  speed: 3000,
  fade: true,
  autoHeight: true,
  speed: 1500,
  swipe: false,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              autoHeight: false,
              adaptiveHeight: true,
          }
      }
  ]
});

$.each($('.digital-muses__block-slider_line-2'), function() {
  var $sl = $(this)
  var w = 0;
  tick = setInterval(function () {
      var v = w / (9000 );
      $sl.css({
          transform: 'scale(' + v + ', 1)' 
      })
      w += 10;
      if (w % 3000 === 0) {
          $('.digital-muses__block-slider_imgs').slick('next');
      }
      if (v >= 1) {
          w = 0;
      }
  }, 10);
})



$('.service-block--option_1 .service__option').on('click touch', function () {
  if ($(window).width() <= 768) {
      $('.service-block--option_1 .service__option:nth-child(' + ($(this).index() + 1) + ')').after($('.service-block--option_1 .service__right--options'));
  }

  $('.service-block--option_1 .service__option--active').removeClass('service__option--active');
  
  $(this).addClass('service__option--active');
  $('.service-block--option_1 .service-option__img--active').removeClass('service-option__img--active');
  $('.service-block--option_1 .service-option__img').eq($(this).index()).addClass('service-option__img--active');
});

$('.service-block--option_2 .service__option').on('click touch', function () {
  if ($(window).width() <= 768) {
      $('.service-block--option_2 .service__option:nth-child(' + ($(this).index() + 1) + ')').after($('.service-block--option_2 .service__right--options'));
  }

  $('.service-block--option_2 .service__option--active').removeClass('service__option--active');
  $(this).addClass('service__option--active');
  $('.service-block--option_2 .service-option__img--active').removeClass('service-option__img--active');
  $('.service-block--option_2 .service-option__img').eq($(this).index()).addClass('service-option__img--active');
});

var servicePc = true;
if ($(window).width() <= 768) {
  servicePc = false;
}

$(window).on('resize', function () {
  if ($(window).width() <= 768) {
      if (servicePc) {
          servicePc = false;
          $('.service-block--option_1 .service__option:nth-child(' + ($('.service-block--option_1 .service-option__img--active').index() + 1) + ')').after($('.service-block--option_1 .service__right--options'));
          $('.service-block--option_2 .service__option:nth-child(' + ($('.service-block--option_2 .service-option__img--active').index() + 1) + ')').after($('.service-block--option_2 .service__right--options'));
      } 
  } else {
      if (!servicePc) {
          servicePc = true;
          $('.service-block--option_1 .service__content').append($('.service-block--option_1 .service__right--options'));
          $('.service-block--option_2 .service__content').append($('.service-block--option_2 .service__right--options'))
      } 
  }
});

$('.service-faq__q').on('click touch', function () {
  var isCurrent = $(this).parent().hasClass('service-faq--active');
  if (isCurrent) {
      $(this).removeClass('service-faq__q--active');
      $(this).parent().find('.service-faq__a').removeClass('service-faq__a--active');
      $(this).parent().removeClass('service-faq--active');
  } else {
      $(this).addClass('service-faq__q--active');
      $(this).parent().find('.service-faq__a').addClass('service-faq__a--active');
      $(this).parent().addClass('service-faq--active');
  }
})

if ($(window).width() <= 768) {
  $('.service-block--option_1 .service__option:nth-child(1)').after($('.service-block--option_1 .service__right--options'));
  $('.service-block--option_2 .service__option:nth-child(1)').after($('.service-block--option_2 .service__right--options'));
}

$('.service-review__link').on('click', function () {
  $('.service-review').show();
  $(this).hide();
  return false;
})


$('.over__header-content').slick({
  slidesToShow: 1,
  dots:false,
  prevArrow: '<button class="over__header-button"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"></path></svg></button>',
  nextArrow: '<button class="over__header-button over__header-button--right"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2"></path></svg></button>',
  autoplay: true,
  autoplaySpeed: 6000,
  speed: 300
});


$('.js-privacy-agree').on('click', function() {
  localStorage.setItem('privacy_agree', 1);
  $(this).parent().hide();
  return false;
})

if (!localStorage.getItem('privacy_agree')) {
  $('.js-privacy').fadeIn();
}

var ua = navigator.userAgent.toLowerCase(); 
if ((ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) || ua.match(/iPhone/i)) { 
  $('body').addClass('safari');
}

document.addEventListener("rebuy:cart.change", (event) => {
  $('#cart-icon-bubble span').text(event.detail.cart.itemCount());
  if (window.customerTags && window.customerTags.join(',').indexOf('pro') !== -1) {
    if (event.detail.cart.subtotal() < 50000) {
      $('.rebuy-button.rebuy-cart__checkout-button.block').attr('disabled', true);
      $('.rebuy-button.rebuy-cart__checkout-button.block').text('Minimum purchase $500.00 or more');
    } else {
      $('.rebuy-button.rebuy-cart__checkout-button.block').attr('disabled', false);
      $('.rebuy-button.rebuy-cart__checkout-button.block').text('Checkout');
    }
  }
});


document.addEventListener('rebuy:smartcart.ready', (event) => {
  if ($('cart-drawer.drawer.active').length) {
    event.detail.smartcart.show()
    $('cart-drawer.drawer.active').removeClass('active');
    document.body.classList.remove('overflow-hidden');
  }
});

var discount = 0;
var setDiscount = 0;
if (customerTags.indexOf('pro_40') !== -1) {
  setDiscount = discount = 40;
} else if (customerTags.indexOf('pro_30') !== -1) {
  setDiscount = discount = 30;
} else if (customerTags.indexOf('pro_50') !== -1) {
  discount = 50;
}
if (discount > 0) {
  
  $.ajax('/discount/PRO' + discount);
  $.each($('.js-current-price'), function () {
    if (!setDiscount && !$(this).parents('.big-products--oneproduct').length) {
      return;
    }
    var oldPrice = $(this).text().replace('$', '');
    var price = (Math.round((oldPrice - oldPrice * discount / 100) * 100) / 100).toFixed(2);
    $(this).html('$' + price);
    if (!$(this).parent().find('.button__price-old').length) {
      $(this).prepend('<span class="button__price-old">$' + oldPrice + '</span>')
    }
  })
}

$('.ameonpro-info__sub-tit').on('click touch', function() {
  $(this).siblings('.ameonpro-info__sub').toggleClass('ameonpro-info__sub--active');
  $(this).parent().find('.ameonpro-info__sub-tit').toggleClass('ameonpro-info__sub-tit--active');
})

if (document.location.hash === '#restore-password') {
  showRecoveryPassword();
}

$('.js-reset-password').on('click touch', function() {
  showRecoveryPassword();
  return false;
})

function showRecoveryPassword() {
  $('#customer_login').hide();
  $('#recover_customer_password').show();
}


$("form#reg_form").on('submit', function(e) {
  e.preventDefault();    
  var formData = new FormData(this);
  $('.error').text('');
  var $btn = $(this).find('button');
  $btn.text('Loading...');
  $btn.attr('disabled', true);
  $.ajax({
      url: 'https://api.ameonskin.com/v1/pro/request/',
      type: 'POST',
      data: formData,
      success: function (data) {
        $btn.text('Apply');
        $btn.attr('disabled', false);
        if (data.success) {
          $('.popup--thank').show();
        } else if (data.code === 422) {
          var keys = Object.keys(data.data);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            $('.error_' + key).text(data.data[key]);
          }
        } else {
          $('.submit-error').text('Error has occurred. Please try again later.');
        }
      },
      error: function() {
        $('.submit-error').text('Error has occurred. Please try again later.');
        $btn.text('Apply');
        $btn.attr('disabled', false);
      },
      cache: false,
      contentType: false,
      processData: false
  });
});

$('.ameonpro-reg__form-upload_input').on('change', function (e) {
  if (e.target.files[0]) {
      $(this).parent().find('span').text(e.target.files[0].name)
  }
});

$('.popup--thank').on('click touch', function() {
  $('.popup--thank').fadeOut();
});


$('.menu-location__current').on('click touch', function () {
  $('.menu-location').toggleClass('menu-location--active')
})

$('.location-wrapper, .location__btn').on('click touch', function () {
  $('.location-wrapper').fadeOut();
});

$('.location-block__current').on('click touch', function () {
  $('.location-block').toggleClass('location-block--active')
})
$('.location').on('click touch', function (e) {
  e.stopPropagation();
})

function showLocationPopup() {
  if (!localStorage.getItem('location-popup-shown')) {
    localStorage.setItem('location-popup-shown', 1);
    $('.location-wrapper').fadeIn();
  }
}

function getLocation() {
  $.ajax({
    type: 'get',
    url: 'https://api.ameonskin.com/v1/location',
    success: function (e) {
      if (e.success && (e.data.region === 'uk' || e.data.region === 'eu')) {
        $('.location__btn').not('.location__btn--' + e.data.region).hide();
        $('.location-block__current').not('.location-block__current--' + e.data.region).hide();
        $('body').addClass('show-location');
        showLocationPopup();
      } 
    },
    dataType: 'json'
  });
}


if ($('.modal__wrapper--welcome').length && !$('.promo-modal').length && !localStorage.getItem('subscribe_shown') && !$('.modal__wrapper--bf').length) {
  
  // setTimeout(function () {
  //   $('.modal__wrapper--welcome').fadeIn();
  //   localStorage.setItem('subscribe_shown', 1);
  // }, 12000)
}


// if ($('.promo-hotsummer').length && !localStorage.getItem('promo-hotsummer')) {
  
//   setTimeout(function () {
//     $('.promo-hotsummer').fadeIn();
//     localStorage.setItem('promo-hotsummer', 1);
//   }, 12000)
// }


if (!$('.modal__wrapper--bf').length) {
  //getLocation();  
} else {
  // if (!localStorage.getItem('bfpopup')) {
  //   localStorage.setItem('bfpopup', 1)
  //   $('.modal__wrapper--bf').fadeIn();
  // }
}


$(".clothing-video__desktop").on("mouseover", function() {
  this.play();
});

$(".clothing-video__desktop").on("mouseout", function() {
  this.pause();
});

$('.clothing-info__guide').on('click touch', function() {
  $('.modal__wrapper--size-table').fadeIn();
  return false;
});

$('.modal-block__switch').on('click touch', function() {
  $('.modal-block__switch--active').removeClass('modal-block__switch--active');
  $(this).addClass('modal-block__switch--active');

  $('.js-size-table').hide();
  $('.js-size-table-' + $(this).data('type')).show();
  return false;
})

$('.clothing-info__size-input').on('change', function() {
  var val = $(this).val();
  $(this).parents('.clothing-info__form').find('.product-form').find('.product-variant-id').val(val);
});


$('.ameon-product__right .product__rating').on('click touch', function() {
  $([document.documentElement, document.body]).animate({
    scrollTop: $(".ameon-reviews__wrapper").offset().top - 150,
  }, 500);
});


$('.changes__list').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  dots:true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }
  ]
});


var hash = document.location.hash;

if (hash && hash.indexOf('review-rating-') !== -1) {
  $('.write-review').show();
  var rating = hash.replace('#review-rating-', '');
  $('label[for="star' + rating + '"]').click();
}


$('.slider-block__list').slick({
  slidesToShow: 4,
  dots:true,
  arrows: false,
  slidesToScroll: 4,
  //centerMode: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        //centerMode: true,
      }
    }
  ]
});